import axios from "@/services/api/utils/interceptors";
import { IBasicEntity } from "@/services/interfaces";
import { AxiosError } from "axios";

export default async (params: IBasicEntity): Promise<any> => {
  let url = `/api/catalog/products`;

  if (params.id) {
    url += `/${params.id}`;
  }

  try {
    const res = await axios.get(url);
    const body = res.data;
    return {
      status: res.status,
      data: body,
    };
  } catch (err) {
    const Error = err as AxiosError;
    return {
      data: Error.response?.data,
      status: Error.response?.status,
    };
  }
};
